export class SplatImage {

    name: string;
    url: string;
    img: HTMLImageElement;
    size: { w: number, h: number } = {w: undefined, h: undefined};

    constructor(name: string, url: string) {
        this.name = name;
        this.url = url;
    }

    load(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.img = document.createElement("img");
            this.img.src = this.url;
            this.img.onload = () => {
                this.size = {
                    w: this.img.naturalWidth,
                    h: this.img.naturalHeight
                };
                resolve();
            };

            this.img.onerror = () => {
                reject();
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-image.model.ts